module.exports = __webpack_public_path__ + "img/5962bf8.png";